import React from "react";
import { Card } from "@/components/ui/card";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, PieChart, Pie, Cell, LabelList } from "recharts";

const C = { Sailing: "#2E86DE", Spot: "#F39C12", SWGP: "#9AA5B1", navy: "#1F3A5F", teal: "#2A9D8F", gold: "#D4AF37" };
const tip = { contentStyle: { background: "hsl(var(--popover))", border: "1px solid rgba(212,175,55,0.3)", borderRadius: 8, fontSize: 12 } };
const axis = { tick: { fill: "hsl(var(--muted-foreground))", fontSize: 11 }, stroke: "rgba(255,255,255,0.08)" };

const Panel = ({ title, children, testid, h = 260 }) => (
  <Card className="gold-ring glass p-4" data-testid={testid}>
    <p className="mb-2 text-center text-sm font-700">{title}</p>
    <div style={{ height: h }}><ResponsiveContainer width="100%" height="100%">{children}</ResponsiveContainer></div>
  </Card>
);
const Section = ({ title, children }) => (
  <section>
    <h3 className="mb-3 rounded-md bg-[hsl(var(--primary))] px-3 py-1.5 font-display text-sm font-700 uppercase tracking-wider text-[hsl(var(--primary-foreground))]">{title}</h3>
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">{children}</div>
  </section>
);
const Stacked = ({ data }) => (
  <BarChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
    <XAxis dataKey="label" {...axis} /><YAxis {...axis} allowDecimals={false} /><Tooltip {...tip} /><Legend wrapperStyle={{ fontSize: 11 }} />
    <Bar dataKey="Sailing" stackId="a" fill={C.Sailing} /><Bar dataKey="Spot" stackId="a" fill={C.Spot} /><Bar dataKey="SWGP" stackId="a" fill={C.SWGP} radius={[3, 3, 0, 0]} />
  </BarChart>
);
const HBar = ({ data, dataKey, fill, fmt }) => (
  <BarChart data={data} layout="vertical" margin={{ top: 5, right: 40, left: 10, bottom: 0 }}>
    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" horizontal={false} />
    <XAxis type="number" {...axis} allowDecimals={false} /><YAxis type="category" dataKey="label" width={80} {...axis} /><Tooltip {...tip} formatter={fmt} />
    <Bar dataKey={dataKey} fill={fill} radius={[0, 4, 4, 0]} barSize={18}><LabelList dataKey={dataKey} position="right" formatter={fmt} style={{ fill: "hsl(var(--foreground))", fontSize: 11 }} /></Bar>
  </BarChart>
);

export default function Charts({ stats }) {
  const mix = Object.entries(stats.by_status).map(([name, value]) => ({ name, value })).filter((x) => x.value > 0);
  const pctFmt = (v) => `${v}%`;
  return (
    <div className="space-y-6" data-testid="population-charts">
      <Section title="Membership by designation and status">
        <Panel title="Designation by Status" testid="chart-designation-status"><Stacked data={stats.designations} /></Panel>
        <Panel title="Status Mix" testid="chart-status-mix">
          <PieChart>
            <Pie data={mix} dataKey="value" nameKey="name" innerRadius="52%" outerRadius="80%" paddingAngle={2} stroke="none">{mix.map((m) => <Cell key={m.name} fill={C[m.name]} />)}</Pie>
            <Tooltip {...tip} /><Legend layout="vertical" align="right" verticalAlign="middle" wrapperStyle={{ fontSize: 12 }} />
          </PieChart>
        </Panel>
      </Section>
      <Section title="Designation mix and spot rate">
        <Panel title="Members by Designation" testid="chart-designation-count"><HBar data={stats.designations} dataKey="total" fill={C.navy} /></Panel>
        <Panel title="Spot Rate by Designation (% on Spot)" testid="chart-spot-rate"><HBar data={stats.designations} dataKey="spot_rate" fill={C.Spot} fmt={pctFmt} /></Panel>
      </Section>
      <Section title="Members by frigate">
        <Panel title="Members by Frigate" testid="chart-frigate-count"><HBar data={stats.frigates} dataKey="total" fill={C.teal} /></Panel>
        <Panel title="Frigate by Status" testid="chart-frigate-status"><Stacked data={stats.frigates} /></Panel>
      </Section>
    </div>
  );
}
